import { render } from "./StartedSectionComponents.vue?vue&type=template&id=647c1557"
import script from "./StartedSectionComponents.vue?vue&type=script&lang=js"
export * from "./StartedSectionComponents.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dhaffaabdillah/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__